export default class Utils {
  constructor() {
    this.initSkipTranslate();
  }

  initSkipTranslate() {
    const setIframeTitle = () => {
      const iframe = document.querySelector('iframe[src*="translate.google.com"]');
      console.log('1');
      

      if (!iframe) return false;

      iframe.setAttribute('title', 'Google Translate');
      return true;
    };

    if (setIframeTitle()) return;

    const observer = new MutationObserver(() => {
      if (setIframeTitle()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}